import { DatePickerInput, DatePickerInputProps, DatePickerType } from '@mantine/dates';

import { FieldCaption } from '../../input/FieldCaption';
import compactClasses from '../../input/compactField.module.css';

import classes from './DateField.module.css';

type DateFieldProps<Type extends DatePickerType> = DatePickerInputProps<Type> & {
	/** Компактный вариант для десктопных фильтров и форм админки */
	compact?: boolean;
};

export const DateField = <Type extends DatePickerType = 'default'>({
	compact = false,
	...props
}: DateFieldProps<Type>) => {
	return (
		<DatePickerInput<Type>
			{...props}
			classNames={compact ? compactClasses : classes}
			radius="lg"
			valueFormat="DD.MM.YYYY"
			label={<FieldCaption compact={compact}>{props.label}</FieldCaption>}
			size={compact ? 'sm' : 'md'}
		/>
	);
};
